function set(sess, user) {
    const { User } = sess;
    if (User.all().count() !== 0) {
        User.all().at(0).update(user);
    } else {
        User.create(user);
    }
}

function dump(sess) {
    const { User } = sess;
    if (User.all().count() !== 0) {
        User.all().delete();
    }
}

function setAttachments(sess, attachment) {
    const {Attachment, User} = sess;
    const attachmentsModel = attachment.map(at => {
        return Attachment.create(at);
    });
    if (User.all().exists()) {
        User.all().at(0).update({
            attachments: attachmentsModel,
        });
    } else {
        throw new Error('there is not any user in db state!');
    }
}

function updateUserPicture(sess, userPicturePath) {
    const { User } = sess;
    if (User.all().count() === 0) {
        throw new Error('there is not any user!');
    }
    User.all().at(0).update({
        image: userPicturePath,
    });
}

function changeEmail(sess, email) {
    const { User } = sess;
    if (User.all().count() === 0) {
        throw new Error('there is not any user!');
    }
    User.all().at(0).update({
        emailVerified: false,
        email
    });
}

function create(sess, user) {
    const { ForumUser } = sess;
    return ForumUser.create(user)
}


export default {
    set,
    dump,
    setAttachments,
    updateUserPicture,
    changeEmail,
    create
}